import { v4 as uuidv4 } from 'uuid';
import { ColorInterval } from '../../reportsTypes';

type ColorsInput = {
  colors: Array<{
    val: any; // Not used in the conversion
    rgb: string;
    sVal: number;
    eVal: number;
  }>;
};

export function convertBackToColorIntervals(
  input: ColorsInput | undefined,
): ColorInterval[] {
  if (!input) {
    return [];
  }

  return input.colors.map((item, _index) => ({
    id: uuidv4(),
    color: item.rgb,
    startInterval: item.sVal,
    endInterval: item.eVal,
  }));
}
